import store from "@/store/index.js";
import router from "@/router/index.js";
import { eventBus } from "@/plugins/eventBus";
import AES from "@/mixins/AES";
const operatePage = [
  {
    componentName: "operateGoods",
    // children: ["createGoods", "editInventorySkuList"], // 固定顺序，先写新增再写编辑
    children: ["createGoods", "editTheListOfProductSKUs"], // 固定顺序，先写新增再写编辑
  },
  {
    componentName: "operatefirstLegOrderList",
    children: [
      "createoriginReceivingInboundOrder",
      "editOriginReceivingInboundOrder",
    ],
  },
  {
    componentName: "operateRole",
    children: ["createRoleInfo", "editRoleInfo"],
  },
  {
    componentName: "operateValueAddedServiceTask",
    children: ["createValueAddedServiceTask", "editValueAddedServiceTask"],
  },
  {
    componentName: "operateOrder",
    children: ["createOrder", "editOrder"],
  },
  {
    componentName: "operatefirstLegOrderList",
    children: ["Create_a_warehouse_entry", "Edit_the_entry_slip"],
  },
  {
    componentName: "operateStaff",
    children: ["createStaff", "editStaff"],
  },
  {
    componentName: "editFinancialStatement",
    children: ["", "editFinancialStatement"],
  },
  {
    componentName: "operateClient",
    children: ["createClient", "editClient"],
  },
  {
    componentName: "operateCost",
    children: ["createCost", "editCost"],
  },
  {
    componentName: "operateLogisticsChannel",
    children: ["addLogisticsChannel", "editLogisticsChannel"],
  },
  {
    componentName: "operateTransferOutTask",
    children: ["addTransferOutTask", "editTransferOutTask"],
  },
  {
    componentName: "manageAddTransferOutTask",
    children: ["manageAddTransferOutTask", "manageEditTransferOutTask"],
  },
];

/**
 * 在 operatePage 数组的 children 子数组中查找指定字符串的索引
 * @param {string} target - 要查找的目标字符串
 * @returns {Object|null} - 包含父对象索引和子数组中索引的对象，如果未找到则返回 null
 */
function findStringInChildren(target) {
  for (let parentIndex = 0; parentIndex < operatePage.length; parentIndex++) {
    const item = operatePage[parentIndex];
    if (item.children) {
      const childIndex = item.children.indexOf(target);
      if (childIndex !== -1) {
        return { parentIndex, childIndex };
      }
    }
  }
  return null;
}

// 生成router-view的key
function generateKey() {
  let menuListData = JSON.parse(
    AES.decrypt(window.localStorage.getItem("menuListData"))
  );
  let data = findMenuPathLevelAndParent(menuListData, this.$route.path);
  if (data?.level == 4) {
    let routeKey = this.$route.fullPath;

    const result = findStringInChildren(this.$route.name);
    if (result) {
      // 新增
      if (result.childIndex == 0) {
        routeKey = this.$route.fullPath + this.addRandomNum;
      }
      // 编辑
      else if (result.childIndex == 1) {
        routeKey = this.$route.fullPath + this.editRandomNum;
      }
    }
    return routeKey;
  }
}

// 重置回初始数据
function resetToInitialData() {
  const originalEditRandomNum = this.editRandomNum;
  const originalAddRandomNum = this.addRandomNum;
  Object.assign(this.$data, deepClone(this.initialData));
  this.editRandomNum = originalEditRandomNum;
  this.addRandomNum = originalAddRandomNum;
}

// 判断当前path位于菜单第几层
function findMenuPathLevelAndParent(
  menuArray,
  targetMenuPath,
  currentLevel = 1,
  parent = null
) {
  // 将目标路径转换为小写
  const lowerCaseTargetMenuPath = targetMenuPath.toLowerCase();
  for (const item of menuArray) {
    if (item.menuPath?.toLowerCase() === lowerCaseTargetMenuPath) {
      return { level: currentLevel, parent };
    }
    if (item.children && item.children.length > 0) {
      const result = findMenuPathLevelAndParent(
        item.children,
        targetMenuPath,
        currentLevel + 1,
        item
      );
      if (result) {
        return result;
      }
    }
  }
  return null;
}

// 获取routeName进行子页面判断
function getRouteName() {
  let menuListData = JSON.parse(
    AES.decrypt(window.localStorage.getItem("menuListData"))
  );
  let data = findMenuPathLevelAndParent(menuListData, this.$route.path);
  if (data.level == 4) {
    return data.parent.menuEnName;
  }
  return this.$route.name;
}

// 创建bus
function createBus() {
  let menuListData = JSON.parse(
    AES.decrypt(window.localStorage.getItem("menuListData"))
  );
  let data = findMenuPathLevelAndParent(menuListData, this.$route.path);
  let emitName = "call-" + this.$route.path + "-function";
  if (data && data.level == 4) {
    emitName = "call-" + data.parent.menuPath + "-function";
  }
  eventBus.$on(emitName, this.resetToInitialData);
}

// 销毁bus
function destroyBus() {
  let menuListData = JSON.parse(
    AES.decrypt(window.localStorage.getItem("menuListData"))
  );
  let data = findMenuPathLevelAndParent(menuListData, this.$route.path);
  let emitName = "call-" + this.$route.path + "-function";
  if (data && data.level == 4) {
    emitName = "call-" + data.parent.menuPath + "-function";
  }
  eventBus.$off(emitName, this.resetToInitialData);
}

// 获取组件名称
function getComponentName(name) {
  return (
    operatePage.find((item) => item.children.includes(name))?.componentName ||
    name
  );
}

// 生成 0 到一百万之间的随机整数
function generateRandomNumber(originalNum) {
  let randomNum;
  do {
    // 生成 0 到一百万之间的随机整数
    randomNum = Math.floor(Math.random() * 1000001);
  } while (randomNum === originalNum);
  return randomNum;
}

// 操作完成返回父页面
function returnToParentAfterCompletingOperation(curPath, pPath) {
  store.commit("DEL_NAV_LIST", curPath);
  // 导航栏模式
  if (store.state.tagsView.hasNavBar) {
    router.push({
      path: pPath,
    });
    let temp = pPath.split("?");
    let result = temp.length > 1 ? temp[0] : pPath;
    let emitName = "call-" + result + "-function";
    eventBus.$emit(emitName);
  }
  // 面包屑模式
  else {
    let pathInfo = router.resolve({
      path: pPath,
    });
    window.open(pathInfo.href), "_blank";
  }
}

// 子页面打开
function childrenPageOpen({ path, query = null, originalRandomNum }) {
  let navList = store.state.tagsView.navList;
  let targetPage = null;
  // 编辑操作
  if (query && originalRandomNum) {
    targetPage = navList.find(
      (item) => item.path === path && isDeepEqual(item.query, query)
    );
  }
  // 新增操作
  else if (!query && originalRandomNum) {
    targetPage = navList.find((item) => item.path === path);
  }

  // 获取一个随机数，用于页面二次打开时区分路由页面
  let randomNum = 0;
  if (targetPage) {
    randomNum = originalRandomNum;
  } else {
    randomNum = generateRandomNumber(originalRandomNum);
  }
  // 导航栏模式
  if (store.state.tagsView.hasNavBar) {
    router.push({
      path: path,
      query: query,
    });
  }
  // 面包屑模式
  else {
    let pathInfo = router.resolve({
      path: path,
      query: query,
    });
    window.open(pathInfo.href), "_blank";
  }
  return randomNum;
}

// 判断对象是否相等
function isDeepEqual(obj1, obj2) {
  // 首先检查两个值是否严格相等
  if (obj1 === obj2) {
    return true;
  }
  // 检查是否为对象类型，并且不为 null
  if (
    typeof obj1 !== "object" ||
    obj1 === null ||
    typeof obj2 !== "object" ||
    obj2 === null
  ) {
    return false;
  }
  // 获取两个对象的键数组
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  // 检查键的数量是否相同
  if (keys1.length !== keys2.length) {
    return false;
  }
  // 递归比较每个属性的值
  for (const key of keys1) {
    if (!keys2.includes(key) || !isDeepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}

// 深拷贝
function deepClone(obj) {
  if (obj === null) return null;
  if (typeof obj !== "object") return obj;
  if (obj instanceof Date) return new Date(obj.getTime());

  let clone = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clone[key] = deepClone(obj[key]);
    }
  }
  return clone;
}

// 判断当前路由风格是否为导航栏风格
function judgeCurrentRouteStyle() {
  let pageStyle = localStorage.getItem("pageStyle");
  if (pageStyle !== null && pageStyle != 0) {
    return false;
  }
  return true;
}
export {
  getComponentName,
  childrenPageOpen,
  deepClone,
  returnToParentAfterCompletingOperation,
  resetToInitialData,
  createBus,
  destroyBus,
  generateKey,
  judgeCurrentRouteStyle,
  getRouteName,
};
